export default __webpack_public_path__ + "static/media/doublechevron.4788cb64.svg";